import { Link, useNavigate } from "react-router";
import styled, { css } from "styled-components";

import { confirmUnsavedChanges } from "../../../modules/unsaved-changes";

const CssDeprecated = css`
    color: red;

    &:after {
        content: " DEPRECATED";
    }
`;

const StyledLink = styled(Link)`
    color: #000;
    display: block;
    padding: 3px 10px;
    text-decoration: none;

    &, & * {
        cursor: pointer;
    }

    &:hover {
        background: #000;
        color: #fff;
    }

    ${ ({ deprecated }) => deprecated && CssDeprecated };
`;

export default function ParameterCard(props) {
    const { parameter, guard } = props;
    const navigate = useNavigate();

    async function onClick(event) {
        if (!guard) return;
        event.preventDefault();
        if (await confirmUnsavedChanges(guard)) navigate(parameter.id);
    }

    return (
        <StyledLink
            deprecated={ parameter.deprecated }
            onClick={ onClick }
            to={ parameter.id }
        >
            <span>{ parameter.name[0].text }</span>
        </StyledLink>
    );
}
